import { render, staticRenderFns } from "./NewNominados.vue?vue&type=template&id=bd084092&"
import script from "./NewNominados.vue?vue&type=script&lang=js&"
export * from "./NewNominados.vue?vue&type=script&lang=js&"
import style0 from "./NewNominados.vue?vue&type=style&index=0&id=bd084092&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports